// 7d · 30d · 90d + "vs previous". (A custom range waits on a DS date-range
// picker — handoff open item.)

import clsx from "clsx";
import { ADMIN_RANGES } from "@paceroo/domain/views/admin";
import type { RangeState } from "../lib/useRange";
import s from "./RangeControl.module.css";

export function RangeControl({ range, compact }: { range: RangeState; compact?: boolean }) {
  return (
    <div className={clsx(s.row, compact && s.tall)}>
      <div className={s.seg} role="radiogroup" aria-label="Date range">
        {ADMIN_RANGES.map((d) => (
          <button
            key={d}
            role="radio"
            aria-checked={range.days === d}
            className={clsx(s.segBtn, range.days === d && s.segBtnOn)}
            onClick={() => range.setDays(d)}
          >
            {d}d
          </button>
        ))}
      </div>
      <button className={s.compare} role="checkbox" aria-checked={range.compare} onClick={() => range.setCompare(!range.compare)}>
        <span className={s.box}>
          <span className={s.dot} style={{ background: range.compare ? "var(--ink)" : "transparent" }} />
        </span>
        {compact ? "vs prev" : "vs previous"}
      </button>
    </div>
  );
}
